module.exports = __webpack_public_path__ + "img/kommune-722.b6f23192.svg";